import { render, staticRenderFns } from "./StudentCohortAddEdit.vue?vue&type=template&id=f8506bca"
import script from "./StudentCohortAddEdit.vue?vue&type=script&lang=js"
export * from "./StudentCohortAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports